/**
 * Creates the random id based on current time in milliseconds (Date.now()) and random float (Math.random()).
 *
 * @returns {string} Random id.
 */
export default function randomId() {
  return Date.now() + "_" + Math.random();
}
